import GlobalConfig, { useGlobalConfig } from "./globalConfig";

export { GlobalConfig, useGlobalConfig };
export default GlobalConfig;
